import * as React from 'react';
import { useFeatureToggles } from '@grandvisionhq/state';
import '../../../../context/actions.js';
import '../../../../context/reducer.js';
import { useSunglassesProductData } from '../../../../context/product-context-hooks.js';
import '../../../../context/ProductContext.js';
import '../../../../context/CmsContext.js';
import { ChannelAvailability } from '../../../../types/product.js';
import '../../../../hooks/useCartDiscountsQuery/types.js';
import '@grandvisionhq/graphql';
import '../../../../operations/queries/get-accessories-by-slug.js';
import '../../../../operations/queries/get-contact-lens-by-slug.js';
import '../../../../operations/queries/get-frames-by-slug.js';
import '../../../../operations/queries/get-solutions-by-slug.js';
import '../../../../operations/queries/get-sunglasses-by-slug.js';
import '../../../../operations/queries/get-ready-reader-by-slug.js';
import '../../../../operations/queries/get-cart-discounts-by-promotion-identifier.js';
import '../../../../operations/queries/get-manufacturer-by-key.js';
import '@grandvisionhq/utils';
import '../../../../hooks/use-product-view-history.js';
import '@grandvisionhq/frk-routing';
import 'classnames';
import '@grandvisionhq/common';
import '@grandvisionhq/iris-ui';
import '@grandvisionhq/elements';
import '@grandvisionhq/icons';
import '@grandvisionhq/forms';
import '@grandvisionhq/analytics';
import '@swc/helpers';
import '@grandvisionhq/svc-tealium/events';
import '@grandvisionhq/svc-tealium/utils';
import '@grandvisionhq/inventory';
import '@grandvisionhq/lib-utils-html';
import '@grandvisionhq/lib-utils-react';
import '@grandvisionhq/carts-v2';
import '@grandvisionhq/lib-visuals';
import '../../../../slots/context.js';
import '@grandvisionhq/content';
import { WITHOUT_RX, WITH_RX } from '../../components/RxableSelect/contants.js';

const SunglassesEcommContext = /*#__PURE__*/ React.createContext({});
const useSunglassesEcommContext = ()=>React.useContext(SunglassesEcommContext)
;
const SunglassesEcommProvider = ({ children ,  })=>{
    const { activeVariant: { channelAvailability  } , product: { isOfferedWithPrescriptions  } ,  } = useSunglassesProductData();
    const { isRxPriceFromEnabled  } = useFeatureToggles();
    const [selectWithRxLens, setSelectWithRxLens] = React.useState(WITHOUT_RX);
    var ref;
    const shouldOpenConfigurator = (ref = isOfferedWithPrescriptions && selectWithRxLens === WITH_RX) !== null && ref !== void 0 ? ref : false;
    const shouldDisplayFromPrice = Boolean(isRxPriceFromEnabled && shouldOpenConfigurator);
    const [isConfiguratorOpen, setIsConfiguratorOpen] = React.useState(false);
    const handleConfiguratorOpen = ()=>{
        setIsConfiguratorOpen(true);
    };
    const handleConfiguratorClose = ()=>{
        setIsConfiguratorOpen(false);
    };
    const productAction = React.useMemo(()=>{
        if (shouldOpenConfigurator) {
            return channelAvailability === ChannelAvailability.ONLINE ? 'OPEN_CONFIGURATOR' : 'OPEN_CONFIGURATOR_UNAVAILABLE';
        }
        return channelAvailability === ChannelAvailability.ONLINE ? 'ADD_TO_CART' : 'ADD_TO_CART_UNAVAILABLE';
    }, [
        shouldOpenConfigurator,
        channelAvailability
    ]);
    const value = {
        productAction,
        selectWithRxLens,
        setSelectWithRxLens,
        isConfiguratorOpen,
        handleConfiguratorOpen,
        handleConfiguratorClose,
        shouldOpenConfigurator,
        shouldDisplayFromPrice
    };
    return /*#__PURE__*/ React.createElement(SunglassesEcommContext.Provider, {
        value: value
    }, children);
};

export { SunglassesEcommContext, SunglassesEcommProvider, useSunglassesEcommContext };
//# sourceMappingURL=SunglassesEcommContext.js.map
